// nuolino-admin/src/components/ui/Spinner.tsx
// Spinner acessível para estados de loading.

import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

export function Spinner({ size = 'md', label = 'Carregando', className }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className={cn('inline-flex', className)}>
      <Loader2 className={cn('animate-spin text-action', sizeClasses[size])} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
